var render = function render(){var _vm=this,_c=_vm._self._c;return _c('three-step-history',{attrs:{"api":"home-bill-delete-request","columns":_vm.columns,"done-word":"ລຶບແລ້ວ","search-label":"ຊື່, ເບີໂທ, CUS_, ເລກບິນ"}})
}
var staticRenderFns = []

export { render, staticRenderFns }